import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "@/config";


Vue.use(Vuex);

const Resources = {
    namespaced: true,
    state: {
        collection: localStorage.getItem('collection'),
        collections: [],
        sections: [],
        resources: [],
        curSection: {},
        loading: false,
    },
    getters: {
        collections: state => state.collections || null,
        sections: state => state.sections || null,
        resources: state => state.resources || null,
        collection: state => state.collection || {},
        curSection: state => state.curSection || {},
        isLoading: state => state.isLoading || false,
    },
    mutations: {
        setCollections(state, collections) {
            state.collections = collections
        },
        setSections(state, sections) {
            state.sections = sections;
        },
        setResources(state, resources) {
            state.resources = resources;
        },
        setCollection(state, collection) {
            state.collection = collection;
            localStorage.setItem('collection', collection.uuid);
        },
        setSection(state, section) {
            state.curSection = section;
        }
    },
    actions: {
        fetchCollections({ rootState, commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(config.API_URL + '/collections', { project: rootState.project.uuid })
                    .then(response => {
                        //console.log(response);
                        commit('setCollections', response.data);
                        resolve();
                    })
                    .catch(error => {
                        console.log(error)
                        reject(error);
                    })
            })
        },
        fetchCurCollection({ commit }, uuid) {
            return new Promise((resolve, reject) => {
                axios
                    .get(config.API_URL + '/collections/' + uuid)
                    .then(response => {
                        commit('setCollection', response.data);
                        resolve();
                    })
                    .catch(error => {
                        commit('setCollection', null);
                        reject(error)
                    });
            });
        },
        fetchSections({ state, commit, dispatch }, uuid) {
            state.loading = true;
            commit('setSections', null);
            commit('setSection', null);
            commit('setResources', null);
            return new Promise((resolve, reject) => {
                axios
                    .get(config.API_URL + '/collections/' + uuid + '/sections')
                    .then(response => {
                        commit('setSections', response.data);
                        commit('setSection', response.data[0]);
                        dispatch('fetchResources', response.data[0].uuid);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        fetchResources({ state, commit }, uuid) {
            return new Promise((resolve, reject) => {
                axios
                    .get(config.API_URL + '/sections/' + uuid)
                    .then(response => {
                        commit('setResources', response.data)
                        resolve();
                    })
                    .catch(error => {
                        commit('setResources', null);
                        reject(error);
                    });
            });
        },
        downloadResource({ }, resource) {
            return new Promise((resolve, reject) => {
                axios({
                    url: config.API_URL + '/resources/' + resource.uuid,
                    method: 'GET',
                    responseType: 'blob',
                })
                    .then((response) => {
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');

                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', resource.filename);
                        document.body.appendChild(fileLink);

                        fileLink.click();

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        }
    }
}

export default Resources;